import * as actions from "../constants/actionTypes";

export const INITIAL_STATE = {
    exploreFeed: [],
    hasMore: true,
    exploreLoader: true,
    filterChange: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_EXPLORE_DATA_SUCCESS:
            localStorage.setItem("loadMoreExplore", false);
            return {
                ...state,
                exploreFeed: action.payload.newData ? action.payload.exploreFeed : [...state.exploreFeed, ...action.payload.exploreFeed],
                hasMore: action.payload.exploreFeed.length >= 5,
                exploreLoader: false,
                filterChange: false
            }
        case actions.SEND_CONTEST_LIKE_FEEDBACK_SUCCESS: {
            const {
                index,
                interactionType,
                mediaIndex
            } = action.payload;

            const {
                exploreFeed
            } = state;
            if (interactionType == "B")
                exploreFeed[index].metadata.medias[mediaIndex].isBookmarkedFlag = !exploreFeed[index].metadata.medias[mediaIndex].isBookmarkedFlag;
            else if (interactionType == "L")
                exploreFeed[index].metadata.medias[mediaIndex].isLikedFlag = !exploreFeed[index].metadata.medias[mediaIndex].isLikedFlag;
            else if (interactionType == "D")
                if (exploreFeed[index].metadata.medias.length <= 1)
                    exploreFeed.splice(index, 1);
                else
                    exploreFeed[index].metadata.medias.splice(mediaIndex, 1);
            return {
                ...state,
                exploreFeed: [...exploreFeed]
            }
        }
        case actions.FILTER_LIST_DATA: {
            return {
                ...state,
                filterChange: true,
            }
        }
        case actions.GIVE_VOTE_SUCCESS_EXPLORE: {
            const {
                exploreFeed
            } = state;
            exploreFeed[action.payload].totalVotes += 1;
            exploreFeed[action.payload].todaysVotes += 1;
            exploreFeed[action.payload].votesByMe += 1;
            exploreFeed[action.payload].isVotedByMe = true;

            return {
                ...state,
                exploreFeed: [...exploreFeed]
            }
        }
        case actions.UPDATE_MEDIA_VIEW_COUNT_EXPLORE_SUCCESS: {
            let {
                payload
            } = action;
            let {
                exploreFeed
            } = state;

            exploreFeed[payload.index].metadata.medias[payload.index1].viewCount += 1;
            return {
                ...state,
                exploreFeed: [...exploreFeed]
            }
        }
        case actions.RESET_EXPLORE_DATA: {
            return {
                ...state,
                exploreFeed: [],
                hasMore: true,
                exploreLoader: true,
                filterChange: false,
            }
        }
        default:
            return state;
    }
}